var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mt-5 font-weight-bold text-primary",domProps:{"textContent":_vm._s(_vm.h1)}}),(_vm.isLecturer)?_c('Courses'):_vm._e(),(_vm.isAdmin)?_c('Admin'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }